<span>{{ displayTime() }}</span>